import { useAuth } from "@clerk/react";
import { createContext, useContext, useMemo, type ReactNode } from "react";

import { ApiClient, normalizeApiBaseUrl } from "./api";

const ApiContext = createContext<ApiClient | null>(null);
const apiBaseUrl = normalizeApiBaseUrl(
  (import.meta.env as Record<string, unknown>)["VITE_API_BASE_URL"],
);

export function ApiProvider({ children }: { readonly children: ReactNode }) {
  const { getToken } = useAuth();
  const client = useMemo(
    () => new ApiClient(() => getToken(), apiBaseUrl),
    [getToken],
  );
  return <ApiClientProvider client={client}>{children}</ApiClientProvider>;
}

export function useApi(): ApiClient {
  const client = useContext(ApiContext);
  if (client === null) throw new Error("ApiProvider is missing");
  return client;
}

/** Explicit client injection for local previews and isolated UI tests. */
export function ApiClientProvider({
  client,
  children,
}: {
  readonly client: ApiClient;
  readonly children: ReactNode;
}) {
  return <ApiContext value={client}>{children}</ApiContext>;
}
